import React, { useEffect, useState } from "react";
import { InputNumber } from "antd";
import ApiService from "../../../core/service/ApiService";

export const AppointmentProvisionNoInput = ({ row, onSuccess }) => {
    const [data, setData] = useState({
        provisionNo: 0
    })

    useEffect(() => {
        setData({
            provisionNo: row.provisionNo
        })
    }, [row]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <InputNumber
                size={'small'}
                disabled={row?.confirmStatus === 2}
                value={data.provisionNo}
                style={{width: '100%'}}
                //prefix={Currency[data.currency]}
                onPressEnter={async (e) => {
                    setData({
                        ...data,
                        provisionNo: e.target.value
                    })
                    const res = await ApiService.Accounting.UpdateProvisionNo(row.appointmentId, e.target.value);

                    if (res.success) {
                        await onSuccess()
                    }
                }}
            />
        </div>
    )
}